import { Box, Typography, Button, } from "@mui/material";
import React, { useEffect, useState } from "react"
import style from "./style";
import { ReactComponent as Download } from "../../../../../assets/AccountingModule/bill_download.svg";
import { ReactComponent as Send } from "../../../../../assets/AccountingModule/bill_send.svg";
const BillView = ({ handleDownload, getViewBill }) => {
  const [billHtml, setBillHtml] = useState("");

  useEffect(() => {
    const fetchBill = async () => {
      const result = await getViewBill();
      setBillHtml(result.__html);
    };
    fetchBill();
  }, [getViewBill]);

  return (
    <>
      <Box sx={style.mainGrid}>
        <Typography variant="h5" sx={style.leaveHeading}>Bill Details</Typography>

        <Box sx={style.textGrid}>
          <Button variant="contained" color="success" sx={style.csvBtns} onClick={handleDownload}><Download />
            {"Download"}
          </Button>

          <Button variant="contained" color="success" sx={style.checkinBtns} ><Send />
            {"Resend Bill"}
          </Button>
        </Box>
      </Box>
      <Box sx={style.whiteSection}>
        <Box dangerouslySetInnerHTML={{ __html: billHtml }} />
      </Box>

    </>
  )
}

export default BillView;